import { Container } from "@mantine/core"
import { Outlet } from "react-router-dom"

import { PageHeader } from "../../layout/PageLayout/PageHeader.tsx"

export type PageLink = {
  label: string
  link: string
  wip?: boolean
}

type Props<T> = {
  title: string
  pages?: PageLink[]
  data?: T
  canGoBack?: boolean
  mainCta?: React.ReactNode
}

export const Page = <T,>({
  title,
  pages,
  data,
  canGoBack = false,
  mainCta,
}: Props<T>) => {
  return (
    <Container
      fluid
      py="var(--tfg-layout-padding-y)"
      px="var(--tfg-layout-padding-x)"
    >
      <PageHeader
        title={title}
        pages={pages}
        canGoBack={canGoBack}
        mainCta={mainCta}
      />
      <Container fluid p={0} py="var(--tfg-layout-padding-y)">
        <Outlet context={data} />
      </Container>
    </Container>
  )
}
